<template>
  <div role="main" class="main">
    <section class="page-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <ul class="breadcrumb">
              <li class="active">Dashboard Pendaftaran</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <!--modal here -->
      <div class="row">
        <div class="col-md-3">
          <sidebar />
        </div>
        <div class="col-md-9">
          <!-- loading here -->
          <!--<flash-message></flash-message>
          <center>
            <pulse-loader style="margin: 15px" :loading="$store.state.formData.loading" color="#696969" size="10px"></pulse-loader>
          </center>
          -->
          <div class="row">
            <div class="col-md-12">
              <div>
                <h2 class="mb-none">
                  <a href="">{{ $store.getters.allArtikel.artikel.judul }}</a>
                </h2>
                <div class="post-meta pl-none">
                  <span
                    ><small
                      ><i class="fa fa-calendar"></i>
                      {{ $store.getters.allArtikel.artikel.tgl_posting }}</small
                    ></span
                  >
                </div>
                <br />
                <div class="post-image single mb-lg">
                  <img
                    :src="$store.getters.allArtikel.artikel.foto"
                    class="img-thumbnail"
                    style="display:block; margin:auto;"
                  />
                  <small
                    ><p class="text-center">
                      {{ $store.getters.allArtikel.artikel.deskripsi_foto }}
                    </p></small
                  >
                </div>
                <div class="row">
                  <div
                    class="col-md-12"
                    v-html="$store.getters.allArtikel.artikel.isi_berita"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row visible-xs">
            <div class="col-md-12">
              <h4 class="heading-primary"><i class="fa fa-bullhorn"></i> Pengumuman</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.pengumuman.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailPengumuman(item.id_pengumuman)"
                    style="cursor: pointer"
                    >{{ item.judul }}</a
                  >
                </li>
              </ul>
              <h4 class="heading-primary"><i class="fa fa-newspaper-o"></i> Artikel</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.artikel.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailArtikel(item.id_berita)"
                    style="cursor: pointer"
                  >
                    {{ item.judul }}</a
                  >
                </li>
                <li>
                  <a @click="() => goToCardArtikel()" style="cursor: pointer">
                    <h6 class="heading-primary">
                      Selengkapnya...
                    </h6>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/page/information/ArtikelDetail.vue